<!-- 产品质量评价申请人信息 -->
<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-07-11 17:02:40
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-07-21 15:44:28
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/ES/ESapply/component/orderInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--  -->
<template>
  <div>
    <el-row>
      <el-col :span="12">
        <span class="e-descriptions-item-label">申请人:</span>
        <span class="e-descriptions-item-content">{{
          applyInfo.applicant
        }}</span>
      </el-col>
      <el-col :span="12">
        <span class="e-descriptions-item-label">联系电话:</span>
        <span class="e-descriptions-item-content">{{ applyInfo.mobile }}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <span class="e-descriptions-item-label">邮箱:</span>
        <span class="e-descriptions-item-content">{{ applyInfo.email }}</span>
      </el-col>
      <el-col :span="12">
        <span class="e-descriptions-item-label">单位地址:</span>
        <span class="e-descriptions-item-content">{{ applyInfo.address }}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <span class="e-descriptions-item-label">生产地址:</span>
        <span class="e-descriptions-item-content">{{ applyInfo.factory }}</span>
      </el-col>
      <!-- <el-col span="12">
        <span class="e-descriptions-item-label">总评价费:</span>
        <span class="e-descriptions-item-content color-red">￥143123.21</span>
      </el-col> -->
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    applyInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },

  components: {},

  computed: {},

  created() {
    console.log(this.applyInfo);
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.e-descriptions-item-label,
.e-descriptions-item-content {
  font-size: 14px;
  color: #333;
  line-height: 1;
  &.color-red {
    color: #e50113;
  }
}
.e-descriptions-item-label {
  display: inline-block;
  width: 80px;
  text-align: right;
  margin-right: 10px;
  flex-shrink: 0;
}
.el-row {
  line-height: 1;
}
.el-row:not(:last-child) {
  margin-bottom: 20px;
}
.el-col {
  display: flex;
}
</style>
